import { render, staticRenderFns } from "./LogoAccountsIndex.vue?vue&type=template&id=768f3348&scoped=true&"
import script from "./LogoAccountsIndex.vue?vue&type=script&lang=js&"
export * from "./LogoAccountsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768f3348",
  null
  
)

export default component.exports